export default __webpack_public_path__ + "bet-icon.png";